import { useTranslation } from "@/hooks/useTranslation";
import { Route } from "@/routes/st-admin/management/index";
import { Icon, TabItem, Tabs, TabsList, Typography } from "@st-marketplace/ui";
import { useNavigate } from "@tanstack/react-router";
import { STAdminBanners } from "../banners";
import { STAdminSettings } from "../settings";

type ManagementTab = "settings" | "banners";

const STAdminManagement = () => {
	const { t } = useTranslation();
	const navigate = useNavigate({ from: "/st-admin/management" });
	const { tab = "settings" } = Route.useSearch();

	return (
		<div className="flex flex-col gap-6">
			<Typography variant="title-md" as="h1">
				{t("admin.menuManagement")}
			</Typography>

			<Tabs
				value={tab}
				onValueChange={(value) =>
					navigate({ search: { tab: value as ManagementTab }, replace: true })
				}
			>
				<TabsList className="overflow-x-auto">
					<TabItem value="settings" Icon={<Icon name="settings-3-line" />}>
						{t("admin.management.settings")}
					</TabItem>
					<TabItem value="banners" Icon={<Icon name="notification-3-line" />}>
						{t("admin.management.banners")}
					</TabItem>
				</TabsList>
			</Tabs>

			{tab === "settings" ? <STAdminSettings /> : <STAdminBanners />}
		</div>
	);
};

export default STAdminManagement;
